export default "__VITE_ASSET__B5qv282M__"